import React, { useEffect } from "react";
import { Footer, Header } from "./components";
import { Switch, Route, useLocation, Redirect } from "react-router-dom";
import LandingPage from "./views/LandingPage/Landing.page";
import QuizPage from "./views/Quiz/Quiz.page";
import VideoPage from "./views/Video/Video.page";
import FinalQuizPage from "./views/FinalQuiz/FinalQuiz.page";
import { ThemeProvider } from "styled-components";
import { theme } from "./Theme";
import { observer, inject } from "mobx-react";
import Store from "./state/store";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Actions from "./state/actions";
import ResourcePage from "./views/ResourcePage/Resource.page";

interface Props {
  store?: Store;
  mutator?: Actions;
}

const App: React.FC<Props> = (props) => {
  const { content } = props.store!;
  const location = useLocation();

  const progress = () => {
    if (location.pathname === "/final-quiz") return content.sections.length + 1;
    for (let i = 0, n = content.sections.length; i < n; i++) {
      if (location.pathname.includes(content.sections[i].id)) return i + 1;
    }
    return 0;
  };

  useEffect(() => {
    return () => {
      props.mutator?.closeScorm();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div style={{ position: "relative", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        {location.pathname !== "/" && (
          <Header
            header={content.branding.header}
            shouldDisplayBanner
            logo={content.branding.logo}
            title={content.branding.title}
            subtitle={content.branding.subtitle || ""}
            color="#fff"
          />
        )}

        <div style={{ paddingBottom: "3em", flexGrow: 2 }}>
          <Switch location={location}>
            {content.sections.map((section) => (
              <Route
                key={section.id}
                path={`/section/${section.id}`}
                render={(props) => {
                  if (section.type === "resources") return <ResourcePage idSection={section.id} {...props} />;
                  if (section.type === "finalQuiz") return <FinalQuizPage {...props} />;
                  if (section.type === "quiz") return <QuizPage {...props} idSection={section.id} />;
                  else return <VideoPage {...props} idSection={section.id} />;
                }}
              />
            ))}
            <Route path={"/final-quiz"} render={(props) => <FinalQuizPage {...props} />} />

            <Redirect from="/home" to={`/section/${content.sections[0].id}`} />
            <Route path="/" render={(props) => <LandingPage {...props} />} />
          </Switch>
        </div>
        <Footer itemList={content.footer} />
      </div>
    </ThemeProvider>
  );
};

export default inject("store", "mutator")(observer(App));
